import {useParams} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
import {IGetPublicInfoShowRes} from "@evennt-tech/api-v2-external";
import {apiV2} from "api/firebase";
import {RequestKey} from "api/request-key";
import {toQueryLanguageCode} from "hooks/translation/useLocalisedLanguageCode";

type UseCurrentPublicShowResult = [IGetPublicInfoShowRes | undefined, boolean];

type UseCurrentPublicShowOptions = {
  showId?: string;
  enabled?: boolean;
  /** Render the name and venue in this language (FS-3279). */
  languageCode?: string;
};

const useCurrentPublicShow = (
  options: UseCurrentPublicShowOptions = {}
): UseCurrentPublicShowResult => {
  const {showId: providedShowId, enabled = true} = options;
  const languageCode = toQueryLanguageCode(options.languageCode);

  const {showId: routeShowId} = useParams();
  const showId = providedShowId ?? routeShowId ?? "";

  const {data, isFetching} = useQuery({
    queryKey: [RequestKey.GetPublicShowApiV2, showId, languageCode],
    queryFn: () => apiV2.show.getPublicInfo({showId, languageCode}),
    enabled: enabled && !!showId,
    staleTime: 5_000,
    refetchOnWindowFocus: false,
  });

  return [data, isFetching];
};

export default useCurrentPublicShow;
